module.exports = __webpack_public_path__ + "static/img/female-bg-es.480b54a0.png";